<template>
  <div class="courseware-dialog-container">
    <el-dialog 
      :title="isEditCourseware ? '编辑课时' : '新增课时'" 
      append-to-body="true" 
      :visible="coursewareDialogVisible" 
      width="45%" 
      :close-on-click-modal="false"
      @close="$emit('close')"
    >
      <el-form label-position="top" ref="coursewareForm" :model="coursewareForm" size="medium">
        <el-form-item label="课时类型">
          <el-input :value="getLabelByCode(currentSelectedModeCode)" disabled></el-input>
        </el-form-item>
        <el-form-item label="课时名称" prop="name" :rules="{ required: true, message: '课时名称不能为空', trigger: 'blur' }">
          <el-input v-model="coursewareForm.name" maxlength="512"></el-input>
        </el-form-item>
        <el-form-item label="课时名称（英文）" prop="nameEn" :rules="{ required: true, message: '课时名称英文不能为空', trigger: 'blur' }">
          <el-input v-model="coursewareForm.nameEn" maxlength="512"></el-input>
        </el-form-item>
        <el-form-item label="课时介绍" prop="description">
          <rich-text-editor
            v-if="coursewareDialogVisible"
            v-model="coursewareForm.description" 
            placeholder="输入课时介绍" 
            :ossImageFolder="ossImageFolder" 
            :ossFileFolder="ossFileFolder"
            :isShowVideo="false"
            :isShowCustomlink="false"
          >
          </rich-text-editor>
        </el-form-item>
        <el-form-item label="课时介绍（英文）" prop="descriptionEn">
          <rich-text-editor 
            v-if="coursewareDialogVisible"
            v-model="coursewareForm.descriptionEn" 
            placeholder="输入课时介绍（英文）" 
            :ossImageFolder="ossImageFolder" 
            :ossFileFolder="ossFileFolder"
            :isShowVideo="false"
            :isShowCustomlink="false"
          >
          </rich-text-editor>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="coursewareForm.startTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="课时积分" prop="rewardValue">
          <el-input-number placeholder="课时积分" controls-position="right" v-model="coursewareForm.rewardValue" :step="1" :min="0" size="medium" v-input-int></el-input-number>
        </el-form-item>
        <el-form-item v-if="currentSelectedModeCode != coursewareSelectEnums.COMMENT.code" label="是否开启评论区">
          <el-col :span="15">
            <el-switch v-model="coursewareForm.commentActive"></el-switch>
          </el-col>
        </el-form-item>
        <template v-if="currentSelectedModeCode == coursewareSelectEnums.COMMENT.code" >
          <el-form-item label="发言形式" required>
            <el-col :span="12">
              <el-select v-model="coursewareForm.commentType">
                <el-option v-for="(item, index) in coursewareCommentTypeOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="发言次数限制" required>
            <el-col :span="12">
              <el-select v-model="coursewareForm.commentLimitCount">
                <el-option v-for="(item, index) in coursewareCommentLimitCountOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <el-form-item 
          v-if="currentSelectedModeCode == coursewareSelectEnums.PDF.code || currentSelectedModeCode == coursewareSelectEnums.VIDEO.code" 
          required 
          :error="errorMsg"
        >
          <template #label>
            关联{{ getLabelByCode(currentSelectedModeCode) }}课件
          </template>
          <el-col>
            <div v-if="coursewareForm.coursewareId" style="display:flex">
              <span>
                {{ coursewareForm.coursewareName}}
              </span>
              <el-button
                type="text"
                icon="icon-remove-image"
                @click="removeCoursewareSelected"
              />
            </div>
            <el-button
              v-else
              type="text"
              icon="icon-add-cover"
              @click="showCoursewareSelector = true"
            />
          </el-col>
        </el-form-item>
        <template v-if="isEditCourseware">
          <el-form-item label="创建人">
            <el-input v-model="coursewareForm.creator" disabled></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="coursewareForm.insertedTime" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button type="primary" @click="saveCourseware">确定</el-button>
      </span>
    </el-dialog>
    <courseware-selector 
      v-if="showCoursewareSelector" 
      :dialogVisible="showCoursewareSelector"
      :selected-type="currentSelectedModeCode"
      @close="showCoursewareSelector=false" 
      @confirm-select="handleSelectCourseware"
    />
  </div>
</template>

<script>
import {coursewareSelectEnums, coursewareCommentLimitCountOptions, coursewareCommentTypeOptions } from '@/const/crud/app/course';
import { getOSSCourse, getOSSFileCourse } from '@/api/basic/aliyunoss';
import { addCourseCourseware, editCourseCourseware } from '@/api/app/course';
import CoursewareSelector from './CoursewareSelector.vue';
import RichTextEditor from '@/components/rich-text-editor/index.vue';

export default {
  components: {
    RichTextEditor,
    CoursewareSelector,
  },
  name: "CoursewareDialog",
  props: {
    isEditCourseware: {
      type: Boolean,
      required: false,
      default: false,
    },
    coursewareDialogVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    coursewareForm: {
      type: Object,
      required: true,
    },
    currentSelectedModeCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
      errorMsg: '',
      ossImageFolder: getOSSCourse(),
      ossFileFolder: getOSSFileCourse(),
      showCoursewareSelector: false,
      coursewareSelectEnums: coursewareSelectEnums,
      coursewareCommentLimitCountOptions: coursewareCommentLimitCountOptions,
      coursewareCommentTypeOptions: coursewareCommentTypeOptions,
    }
  },
  created() {
  },
  methods: {
    getLabelByCode(code) {
      for (let key in this.coursewareSelectEnums) {
        if (this.coursewareSelectEnums[key].code === code) {
          return this.coursewareSelectEnums[key].label;
        }
      }
      return '';
    },
    async saveCourseware() {
      if (!this.coursewareForm.coursewareId && 
          (this.currentSelectedModeCode == coursewareSelectEnums.PDF.code || this.currentSelectedModeCode == coursewareSelectEnums.VIDEO.code)) {
        this.errorMsg = '课件信息不能为空';
        return;
      }
      if (this.currentSelectedModeCode == coursewareSelectEnums.COMMENT.code) {
        this.coursewareForm.commentActive = false;
      }
      this.$refs.coursewareForm.validate(async (valid, result) => {
        if (valid) {
          let params = {
            courseId: this.coursewareForm.courseId,
            courseChapterId: this.coursewareForm.courseChapterId,
            coursewareId: this.coursewareForm.coursewareId,
            name: this.coursewareForm.name,
            nameEn: this.coursewareForm.nameEn,
            description: this.coursewareForm.description,
            descriptionEn: this.coursewareForm.descriptionEn,
            startTime: this.coursewareForm.startTime,
            rewardValue: this.coursewareForm.rewardValue,
            commentActive: this.coursewareForm.commentActive,
            commentType: this.coursewareForm.commentType,
            commentLimitCount: this.coursewareForm.commentLimitCount,
            type: this.currentSelectedModeCode,
          }
          if (this.isEditCourseware) {
            params.id = this.coursewareForm.id;
          }
          const func = this.isEditCourseware ? editCourseCourseware : addCourseCourseware;
          const response = await this.requestWrapper(func, params);
          if (response.code !== 0) {
            this.$message({
              showClose: true,
              message: response.msg,
              type: 'error',
            });
            return;
          }
          this.$message({
            showClose: true,
            message: this.isEditCourseware ? '编辑成功' :'新增成功',
            type: 'success'
          });
          this.errorMsg = '';
          this.$emit('close');
        }
      });
    },
    removeCoursewareSelected() {
      this.coursewareForm.coursewareId = undefined;
      this.coursewareForm.coursewareName = '';
      this.errorMsg = '课件信息不能为空';
      this.$forceUpdate();
    },
    handleSelectCourseware(selectCourseware) {
      this.coursewareForm.coursewareId = selectCourseware.id;
      this.errorMsg = '';
      this.coursewareForm.coursewareName = selectCourseware.name;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>